import { render } from "./CreatingEmployee.vue?vue&type=template&id=022fbaad&ts=true"
import script from "./CreatingEmployee.vue?vue&type=script&lang=ts"
export * from "./CreatingEmployee.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/azhukovets/.nps/caiman_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__